import styled from '@emotion/styled/macro';
import { colors, views } from '../../../../common/styles/theme.styles';

export const EntitiesList = styled.div`
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const EntitiesListHeader = styled.div`
  display: flex;
  align-items: center;
  color: ${colors.darkGray1};
  font-family: Circular;
  font-weight: 500;
  font-size: 16px;
  line-height: normal;
  padding: 20px;
  border-bottom: 1px solid ${colors.gray3};
  background: #fff;
`;

export const EntitiesListContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const EntityListItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 12px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  background: ${props => props.isSelected ? '#F8F9FA' : 'transparent'};
  border: 1px solid ${colors.lightGray2};
  border-radius: 10px;
  
  &:hover {
    background: ${colors.lightGray1};
    border: 1px solid ${colors.darkGray3};
  }
  
  ${({ isHovered }) => isHovered && `
    background: ${colors.lightGray1};
    border: 1px solid ${colors.darkGray3};
  `}
`;

export const EntityIcon = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 6px;
  background: ${props => props.color || '#DACEE0'};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-family: Circular;
  font-weight: 500;
  font-size: 14px;
  color: ${colors.textPrimary};
  position: relative;
  
  svg {
    width: 20px;
    height: 20px;
  }
`;

export const EntityInfo = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
`;

export const EntityName = styled.div`
  font-family: Circular;
  font-weight: 450;
  line-height: normal;
  color: ${colors.darkGray1};
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const EntityDescription = styled.div`
  font-family: Circular;
  font-weight: 450;
  font-size: 12px;
  line-height: normal;
  color: ${colors.darkGray3};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const AddEntityButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 16px 24px;
  padding: 12px 16px;
  background: transparent;
  border: 2px dashed ${colors.borderMedium};
  border-radius: 8px;
  color: ${colors.textSecondary};
  font-family: Circular;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    border-color: ${colors.selected};
    color: ${colors.selected};
    background: rgba(84, 100, 129, 0.05);
  }
  
  svg {
    width: 16px;
    height: 16px;
    path {
      stroke: ${colors.textSecondary};
    }
  }
`; 

export const AddEntityRowTextWrapper = styled.div`
  display: flex;
  align-items: center;
  color: ${colors.darkGray3};
  font-family: Circular;
  font-size: 12px;
  font-style: normal;
  font-weight: 450;
  line-height: normal;
  ${views.mobile} {
    font-size: 18px;
  }
`; 

export const AddEntityRowIconWrapper = styled.div`
  display: flex;
  width: 32px;
  height: 32px;
  padding: 9px;
  justify-content: center;
  align-items: center;
  background: ${colors.lightGray2};
  border-radius: 6px;
  ${views.tablet} {
    border-radius: 8px;
    border: 1px solid ${colors.gray3};
    background: #fff;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.04), 0px 0px 2px 0px rgba(0, 0, 0, 0.16);
  }
`;

export const AddEntityRowWrapper = styled.div`
  display: flex;
  height: 44px;
  padding: 0px 4px 0px 8px;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  border: 1px dashed ${colors.gray3};
  cursor: pointer;
  :hover {
    ${views.desktop} {
      border: 1px dashed ${colors.darkGray1};
      ${AddEntityRowTextWrapper} {
        color: ${colors.darkGray1};
      }
      ${AddEntityRowIconWrapper} {
        svg {
          path {
            stroke: ${colors.darkGray1};
          }
        }
      }
    }
  }
    ${views.tablet} {
      border: none;
      color: ${colors.darkGray1};
      background: ${colors.lightGray1};
      svg {
        path {
          stroke: ${colors.darkGray2};
        }
      }
    }
`;